<script setup>
import { ref, onMounted, computed, watch, nextTick } from "vue";
import { Button, Icon } from "../../components";
import useChatWidget from "../stores/chatWidget";

const $chatWidget = useChatWidget();
const $globalSetting = computed(() => $chatWidget.getGlobalSettings());
const $config = $chatWidget.getConfig;
const $setting = $chatWidget.getSettings;
const $payload = $chatWidget.getPayload();

const handleConsent = () => {
  const tempPayload = $payload;
  tempPayload.consent = true;
  tempPayload.step = $payload.step + 1;
  $chatWidget.updatePayload(tempPayload);
};
</script>

<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="transform -translate-y-4 opacity-0"
    enter-to-class="transform translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="transform translate-y-0 opacity-100"
    leave-to-class="transform -translate-y-4 opacity-0"
  >
    <div class="px-4 py-[15px]">
      <div class="inline-flex w-[50px]">
        <img
          :src="$globalSetting?.settings?.business?.full_logo_url"
          :alt="$globalSetting?.settings?.business?.name"
          class="w-full object-contain"
        />
      </div>
      <h2 class="font-semibold text-[20px] mt-1.5 mb-1">
        {{ $setting.welcome.question }}
      </h2>
      <p class="font-light text-[14px] text-gray-600 m-0">
        {{ $setting.welcome.answer }}
      </p>
      <div class="flex gap-1.5 mt-[15px]">
        <Button
          @click="handleConsent"
          size="sm"
          buttonStyle="padding: 14px 24px !important;"
          classButton="border-[2px] bg-gray-800 hover:bg-gray-900 border-gray-800 focus:shadow-[0_0_0_4px_rgba(17,24,39,0.10)]"
        >
          <span class="font-normal text-[16px]">Yes, please</span>
        </Button>
      </div>
      <Transition
        enter-active-class="transition duration-300 ease-out"
        enter-from-class="transform -translate-y-4 opacity-0"
        enter-to-class="transform translate-y-0 opacity-100"
        leave-active-class="transition duration-200 ease-in"
        leave-from-class="transform translate-y-0 opacity-100"
        leave-to-class="transform -translate-y-4 opacity-0"
      >
        <div v-if="$payload?.consent" class="p-5 text-right">
          <p
            class="inline-block bg-gray-200 rounded-[8px] p-4 m-0 text-[18px] font-medium"
          >
            Yes, please
          </p>
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<style scoped></style>
